/* ============================================================
   FRUGAL CONFIGURATOR - logique
   2 etapes : mix puis flasques, ajout au panier via /cart/add.js
   ============================================================ */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    var fmt = format || '{{amount}}';

    function num(n, precision, thousands, decimal) {
      if (isNaN(n)) n = 0;
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var frac = parts[1] ? decimal + parts[1] : '';
      return whole + frac;
    }

    var value = '';
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = match ? match[1] : 'amount';

    switch (placeholder) {
      case 'amount': value = num(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = num(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
      case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': value = num(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = num(cents, 2, "'", '.'); break;
      default: value = num(cents, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function init(root) {
    if (!root || root.dataset.frgcReady === '1') return;
    root.dataset.frgcReady = '1';

    var cfgEl = root.querySelector('[data-frgc-config]');
    if (!cfgEl) return;

    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); }
    catch (e) { console.warn('[frugal-configurator] config illisible', e); return; }

    var state = {
      step: 1,
      mix: null,
      qty: { f60: 0, f100: 0 }
    };

    var preselected = root.querySelector('.frgc__card.is-selected:not(.is-disabled)');
    if (!preselected) preselected = root.querySelector('.frgc__card:not(.is-disabled)');
    if (preselected) state.mix = preselected.getAttribute('data-frgc-mix');

    var els = {
      dots: root.querySelectorAll('[data-frgc-dot]'),
      panels: root.querySelectorAll('[data-frgc-panel]'),
      cards: root.querySelectorAll('[data-frgc-mix]'),
      included: root.querySelector('[data-frgc-included]'),
      recap: root.querySelector('[data-frgc-recap]'),
      total: root.querySelector('[data-frgc-total]'),
      submit: root.querySelector('[data-frgc-submit]'),
      next: root.querySelector('[data-frgc-next]'),
      back: root.querySelector('[data-frgc-back]'),
      error: root.querySelector('[data-frgc-error]'),
      fmodal: root.querySelector('[data-frgc-fmodal]')
    };

    function money(c) { return formatMoney(c, cfg.moneyFormat); }

    function currentMix() { return state.mix ? cfg.mixes[state.mix] : null; }

    function total() {
      var mix = currentMix();
      var t = mix ? mix.price : 0;
      Object.keys(state.qty).forEach(function (k) {
        if (cfg.addons[k]) t += cfg.addons[k].price * state.qty[k];
      });
      return t;
    }

    function renderCards() {
      els.cards.forEach(function (c) {
        c.classList.toggle('is-selected', c.getAttribute('data-frgc-mix') === state.mix);
      });
      if (els.next) els.next.disabled = !state.mix;
    }

    function renderIncluded() {
      var mix = currentMix();
      if (!els.included || !mix) return;
      var html = '<strong>' + mix.label + '</strong> : ' + mix.gels + ' gels equivalents. ';
      if (mix.includes && mix.includes.length) {
        html += 'Deja inclus dans ce format : ' + mix.includes.join(', ') + '.';
      } else {
        html += 'Ce format ne contient pas de flasque. Il t\'en faut au moins une pour doser et transporter le mix.';
      }
      els.included.innerHTML = html;
    }

    function renderRecap() {
      var mix = currentMix();
      if (!els.recap) return;
      var rows = [];
      if (mix) rows.push({ label: mix.title || ('Energy Mix ' + mix.label), price: mix.price });
      Object.keys(state.qty).forEach(function (k) {
        var n = state.qty[k];
        if (n > 0 && cfg.addons[k]) {
          rows.push({ label: n + ' x ' + cfg.addons[k].title, price: cfg.addons[k].price * n });
        }
      });
      els.recap.innerHTML = rows.map(function (r) {
        return '<li><span>' + r.label + '</span><span>' + money(r.price) + '</span></li>';
      }).join('');
      if (els.total) els.total.innerHTML = money(total());
    }

    function renderQty() {
      Object.keys(state.qty).forEach(function (k) {
        var el = root.querySelector('[data-frgc-qtyval="' + k + '"]');
        if (el) el.textContent = state.qty[k];
        var minus = root.querySelector('[data-frgc-qty="' + k + '"][data-frgc-delta="-1"]');
        if (minus) minus.disabled = state.qty[k] <= 0;
      });
    }

    function goTo(step) {
      state.step = step;
      els.panels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-frgc-panel') === String(step));
      });
      els.dots.forEach(function (d) {
        d.classList.toggle('is-active', parseInt(d.getAttribute('data-frgc-dot'), 10) <= step);
      });
      if (step === 2) { renderIncluded(); renderRecap(); renderQty(); }
      try {
        root.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      } catch (e) { /* noop */ }
    }

    function showError(msg) {
      if (!els.error) return;
      els.error.textContent = msg;
      els.error.hidden = !msg;
    }

    els.cards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (card.disabled || card.classList.contains('is-disabled')) return;
        state.mix = card.getAttribute('data-frgc-mix');
        renderCards();
      });
    });

    root.querySelectorAll('[data-frgc-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-frgc-qty');
        var delta = parseInt(btn.getAttribute('data-frgc-delta'), 10);
        var next = (state.qty[key] || 0) + delta;
        if (next < 0) next = 0;
        if (next > 10) next = 10;
        state.qty[key] = next;
        renderQty();
        renderRecap();
      });
    });

    if (els.next) els.next.addEventListener('click', function () { if (state.mix) goTo(2); });
    if (els.back) els.back.addEventListener('click', function () { goTo(1); });

    if (els.fmodal) {
      var openF = root.querySelector('[data-frgc-formula]');
      var closeF = root.querySelector('[data-frgc-fclose]');
      if (openF) openF.addEventListener('click', function () { els.fmodal.hidden = false; });
      if (closeF) closeF.addEventListener('click', function () { els.fmodal.hidden = true; });
      els.fmodal.addEventListener('click', function (e) { if (e.target === els.fmodal) els.fmodal.hidden = true; });
    }

    if (els.submit) {
      els.submit.addEventListener('click', function () {
        var mix = currentMix();
        if (!mix || !mix.id) { showError('Choisis d\'abord un format de mix.'); return; }
        showError('');

        var items = [{
          id: mix.id,
          quantity: 1,
          properties: { _source: 'configurateur-frugal' }
        }];
        Object.keys(state.qty).forEach(function (k) {
          if (state.qty[k] > 0 && cfg.addons[k] && cfg.addons[k].id) {
            items.push({
              id: cfg.addons[k].id,
              quantity: state.qty[k],
              properties: { _source: 'configurateur-frugal' }
            });
          }
        });

        els.submit.classList.add('is-loading');
        fetch(cfg.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            els.submit.classList.remove('is-loading');
            if (!res.ok) {
              showError(res.data && res.data.description ? res.data.description : 'Ajout au panier impossible.');
              return;
            }
            window.location.href = cfg.cartUrl;
          })
          .catch(function () {
            els.submit.classList.remove('is-loading');
            showError('Ajout au panier impossible. Reessaie dans un instant.');
          });
      });
    }

    renderCards();
    renderQty();
  }

  function boot() {
    document.querySelectorAll('[data-frgc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  window.frugalConfiguratorInit = boot;
})();